<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XYD2sK/media/FC-9781398461635.jpg?1689450791118" alt="This image is the cover for the book Just Sign Here"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Just Sign Here
      </h1>
      <p class="bookDescription body article font2">
        <p>If you think surgery is only about the drama of an operating theatre, then you should read this book. A delightful collection of anecdotal stories that will take the reader on a journey from boyhood aspiration through surgical training and on to consultant surgical practice that spanned the millennium. All is laid bare as the author describes his joy, anger, frustration, and sadness of life in the clinical environment and beyond. It embraces a period of transition when clinicians were transformed from self-regulating professionals into paid employees controlled by political diktats from Brussels and Westminster. It is an entertaining account of a period of momentous change and advances in the world of surgical healthcare. A penetratingly candid page turner that will make you laugh, cry and huff with indignation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Greatorex
      </h2>
      
      <p class="authorDescription body article">Bob Greatorex is a retired surgeon who trained as both a dental and general surgeon. He spent forty years working in the NHS and alongside clinical work, became an experienced teacher, trainer and examiner in the UK and internationally. Elected to the Council of the Royal College of Surgeons of England, he was seconded onto national committees within the Department of Health. Away from the clinical coalface, he worked for the Care Quality Commission and the Centre for Workforce Intelligence. He is a champion of equality and diversity within the profession and is an enthusiastic supporter of Women in Surgery.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?419095f0